import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import HomePage from "./home/HomePage";
import "./global.css";
import "./styles/home.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <HomePage />
  </StrictMode>
);
